module.exports = __webpack_public_path__ + "img/button-prepaid_medical_scheme.7632a48b.png";